import { FacilityMappingStrategyState } from 'src/routes/Customers/components/OperatorsTab/modules/types';
import { DATA_STRATEGY } from 'src/utils/constants';

export const parseFacilityDictPayload = (
  facilityMappingStrategy: FacilityMappingStrategyState,
): Omit<FacilityMappingStrategyState, 'tenantName'> => {
  return Object.entries(facilityMappingStrategy).reduce(
    (
      acc: FacilityMappingStrategyState,
      [key, { tenantName, strategy, manualGroupIds, ...rest }],
    ) => {
      if (strategy === DATA_STRATEGY.SKIP) return acc;

      acc[key] = {
        ...rest,
        manualGroupIds,
        strategy:
          strategy === DATA_STRATEGY.LINKED ? DATA_STRATEGY.LINK : strategy,
      };

      return acc;
    },
    {},
  );
};
